
define('ldsh!modules/form_editor/templates/editor_custom_privacy', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<h4 data-i18n="formEditor.privacyInformationTitle">Información</h4>\n<div class="ed-form-group js-label-group">\n  <textarea class="js-informationText ed-form-control ed-form-item-full" rows="6">' +
((__t = ( informationText )) == null ? '' : __t) +
'</textarea>\n</div>\n\n<h4 data-i18n="formEditor.generalConditionsTitle">Condiciones Generales</h4>\n<div class="ed-form-group js-label-group">\n  <div class="ed-form-group ed-form-group-file btn--secondary js-browse mb24 e100">\n    <label>\n      <span data-i18n="formEditor.termsLabel"></span>\n      <i class="ed-icon ri-upload-2-line" aria-hidden="true"></i>\n    </label>\n  </div>\n<div class="js-items"></div>\n';

}
return __p
};});

